import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import copy from '../../demo/fixtures/w5/copy.json'
import { Button, Card, GlossaryText, Icon, Toast, ToastHost } from '../../ui'
import { HandToAiDialog } from './HandToAiDialog'
import { MiniLine } from './MiniLine'
import { useW5Live } from './live'
import styles from './AnalysisPage.module.css'

const severityLabels = { bad: '高', warn: '中', ok: '良好' } as const

export function DiagnosisCards() {
  const navigate = useNavigate()
  const { report, charts } = useW5Live()
  const [handoffId, setHandoffId] = useState<string | null>(null)
  const [toast, setToast] = useState<string | null>(null)
  const handoffFinding = report.findings.find((finding) => finding.id === handoffId) ?? null
  return (
    <div className={styles.section} data-scope="diagnosis-cards">
      <div className={styles.sectionHeading}>
        <h2>{copy.sections.diagnosis}</h2>
        <span>{copy.sections.diagnosisHint}</span>
        <i />
      </div>
      <div className={styles.diagnosisGrid}>
        {report.findings.map((finding) => {
          const evidence = finding.evidence
          const chart = evidence?.chart ? charts[evidence.chart] : null
          return (
            <Card className={styles.diagnosisCard} key={finding.title}>
              <div className={styles.diagnosisHead}>
                <span className={`${styles.severity} ${styles[finding.tone]}`}>{severityLabels[finding.tone]}</span>
                <b><GlossaryText text={finding.title} /></b>
              </div>
              <div className={styles.evidence}>
                <p className={styles.evidenceValue}>{evidence?.value}<small><GlossaryText text={evidence?.sub ?? ''} /></small></p>
                {chart && 'vals' in chart ? <MiniLine chart={chart} /> : null}
              </div>
              <p className={styles.why}><b>原因</b> · <GlossaryText text={finding.why} /></p>
              {finding.owner === 'you' ? (
                <div className={styles.diagnosisFoot}>
                  <Button className={styles.smallPrimary} onClick={() => void navigate(`/monitor/${finding.campaignId}`)}>我来处理</Button>
                  <Button className={styles.aiButton} variant="secondary" onClick={() => setHandoffId(finding.id)}>交给 AI</Button>
                </div>
              ) : (
                <div className={styles.diagnosisFoot}>
                  <span className={styles.aiChip}><Icon name="sparkle" size={12} strokeWidth={2} />{finding.handedAt ? `AI 已接手 · ${finding.handedAt}` : finding.state}</span>
                  <span className={styles.caption}><GlossaryText text={finding.todo.split('；')[0] ?? ''} /></span>
                </div>
              )}
            </Card>
          )
        })}
      </div>
      <HandToAiDialog open={Boolean(handoffFinding)} finding={handoffFinding} onClose={() => setHandoffId(null)} onDone={setToast} />
      {toast ? <ToastHost><Toast onDismiss={() => setToast(null)}>{toast}</Toast></ToastHost> : null}
    </div>
  )
}
